import React from "react";
import { getIcon } from "../../constants/constants";

function PlatformDropdown({ platforms, onSelect, onClose }) {
  return (
    <div
      className="bg-body shadow border rounded-3 py-1 conv-platform-dropdown"
      onMouseLeave={onClose}
    >
      {platforms.length === 0 ? (
        <div className="px-3 py-2 text-body-secondary conv-platform-item">
          No integrations installed
        </div>
      ) : (
        platforms.map((platform) => {
          const platformType = platform?.assistantId?.platform?.type;
          const iconUrl = getIcon(platformType);
          return (
            <button
              key={platform.uuid}
              type="button"
              className="btn btn-sm w-100 text-start d-flex align-items-center gap-2 px-3 py-1 border-0 bg-transparent conv-platform-item"
              onClick={() => onSelect(platform)}
            >
              {iconUrl ? (
                <img src={iconUrl} alt={platform.assistantId?.name} width={16} height={16} />
              ) : (
                <i className="bi bi-plug-fill text-primary conv-platform-item" />
              )}
              <span className="text-truncate">{platform.assistantId?.name}</span>
            </button>
          );
        })
      )}
    </div>
  );
}

export default PlatformDropdown;